/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowTriggerEventProcessCreateDto } from '../../models/workflow-trigger-event-process-create-dto';
import { WorkflowTriggerEventProcessDto } from '../../models/workflow-trigger-event-process-dto';

export interface AutomatedProcessCreateTriggerEventProcess$Params {
      body: WorkflowTriggerEventProcessCreateDto
}

export function automatedProcessCreateTriggerEventProcess(http: HttpClient, rootUrl: string, params: AutomatedProcessCreateTriggerEventProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventProcessDto>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessCreateTriggerEventProcess.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkflowTriggerEventProcessDto>;
    })
  );
}

automatedProcessCreateTriggerEventProcess.PATH = '/automated-process/workflow-trigger/trigger-event-process';